import { Search } from 'lucide-react';
import Input from '../atoms/Input';

/**
 * SearchInput — search field with a leading magnifier icon.
 * `onChange` receives the string value (not the event).
 */
export default function SearchInput({
  value,
  onChange,
  placeholder = 'Cari…',
  label,
  className = '',
  ...rest
}) {
  return (
    <div className={`search-input ${className}`.trim()}>
      <Input
        iconPrefix={Search}
        label={label}
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        {...rest}
      />
    </div>
  );
}
